export enum TermActions {
  PERSONAL_GOALS = 'pdp',
  // CULTURE_FEEDBACK to be removed
  CULTURE_FEEDBACK = 'culture_feedback',
  CULTURE_EVALUATION = 'culture_evaluaton',
  TERM_REVIEW = 'term_review',
  DEFINE_CLOSE_MEMBERS = 'define_close_members',
  FINALISE_TERM = 'finalise_term',
  EMPTY_START = 'empty_start',
}

export enum BuiltInPossibleTerms {
  STANDARD_6_MONTHS = 'standard6Months',
  ON_HALT = 'onHalt',
}

export enum TermStepState {
  COMPLETED = 'completed',
  OPEN = 'open',
  UPCOMING = 'upcoming',
}
export interface IActionStep {
  key: string
  action: TermActions
  monthsAfterStart: number
  weeksAfterStart?: number
  specificDateInMonth?: number
  // TODO remove
  settings?: ActionStepSettings
}

export type ActionStepSettings = object

export interface IActionStepWithDate extends IActionStep {
  executionDate: Date
}

export const BuiltInTermConfigurations: { [key: string]: IActionStep[] } = {
  standard6Months: [
    {
      key: 'standard6Months_personal_goals',
      action: TermActions.PERSONAL_GOALS,
      monthsAfterStart: 0,
      weeksAfterStart: 0,
    },
    // {
    //   key: 'standard6Months_define_close_members',
    //   action: TermActions.DEFINE_CLOSE_MEMBERS,
    //   monthsAfterStart: 3,
    //   weeksAfterStart: 3,
    // },
    {
      key: 'standard6Months_term_review',
      action: TermActions.TERM_REVIEW,
      monthsAfterStart: 4,
      weeksAfterStart: 3,
    },
    {
      key: 'standard6Months_term_end',
      action: TermActions.FINALISE_TERM,
      monthsAfterStart: 6,
      weeksAfterStart: 0,
    },
  ],
  onHalt: [
    {
      key: 'onHalt_start',
      action: TermActions.EMPTY_START,
      monthsAfterStart: 0,
      weeksAfterStart: 0,
    },
    {
      key: 'onHalt_end',
      action: TermActions.FINALISE_TERM,
      monthsAfterStart: 12 * 5,
      weeksAfterStart: 0,
    },
  ],
}
